(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('ConcernDeleteController',ConcernDeleteController);

    ConcernDeleteController.$inject = ['$uibModalInstance', 'entity', 'Concern'];

    function ConcernDeleteController($uibModalInstance, entity, Concern) {
        var vm = this;

        vm.concern = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Concern.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
